import { LoadingButton } from "@mui/lab";

import { ManagementCompany } from "../../../types";
import { useSaveManageCompany } from "../../service/useSaveManageCompany";

export default function Save(company: ManagementCompany) {
	const { onSave, isLoading } = useSaveManageCompany();

	return (
		<LoadingButton
			variant='contained'
			size='small'
			onClick={() => onSave(company)}
			loading={isLoading}
		>
			{"Guardar"}
		</LoadingButton>
	);
}
